import { SalutationsTranslationService } from 'src/app/shared/translations';

/**
 * Blueprint for the customer status object.
 */
export class Salutations {
  public value: string;
  public salutations: Array<any> = [
    {
      value: 'mr',
      salutation: this.translationsService.mr
    },
    {
      value: 'mrs',
      salutation: this.translationsService.mrs
    }
  ];

  constructor(private data: string, private translationsService: SalutationsTranslationService) {
    this.value = data;
  }

  public get getTranslatedSalutation(): string | string {
    const translatedSalutation = this.salutations.find((salutation: any) => this.data === salutation.value);
    return translatedSalutation ? translatedSalutation.salutation : this.value;
  }
}
